import { formatLocaleDate } from '../utils/date'

export const useBasketDeliveryEstimate = () => {
  const { $i18n } = useNuxtApp()
  const currentShop = useCurrentShop()

  const getBaskedDeliveryEstimation = (
    deliveryEstimationDate?: string | number,
  ) => {
    if (!deliveryEstimationDate) {
      return {}
    }

    const days = isNaN(deliveryEstimationDate as number)
      ? deliveryEstimationDate
      : Math.ceil(Number(deliveryEstimationDate))

    return {
      'attribute-3': {
        key: 'deliveryForecast',
        label: $i18n.t('checkout.delivery_estimate.label'),
        value: $i18n.t('checkout.delivery_estimate.value', {
          days,
        }),
      },
    }
  }

  const getBaskedDeliveryEstimationWithDate = (
    deliveryEstimation?: Date | undefined,
  ) => {
    if (!deliveryEstimation) {
      return {
        'attribute-3': {
          key: 'deliveryForecast',
          label: $i18n.t('checkout.delivery_estimate_unknown.label'),
          value: $i18n.t('checkout.delivery_estimate_unknown.value'),
        },
      }
    }

    return {
      'attribute-3': {
        key: 'deliveryForecast',
        label: $i18n.t('checkout.delivery_estimate.label'),
        value: String(
          formatLocaleDate(
            String(deliveryEstimation),
            currentShop.value.locale,
          ),
        ),
      },
    }
  }

  return {
    getBaskedDeliveryEstimation,
    getBaskedDeliveryEstimationWithDate,
  }
}
